import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthTokenService } from '../Services/auth-token.service';
import { ErrorHandlerService } from '../Services/error-handler.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const authTokenService = inject(AuthTokenService);
  const router = inject(Router);

  const skipError = req.headers.get('skip-error') === 'true';

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          authTokenService.setReturnUrl(router.url);
        }

        if (!skipError) {
          errorHandler.handleError(error);
        }
      }

      return throwError(() => error);
    }),
  );
};
